import React from 'react';

const ScholarshipsandFellowships = () => {
  return (
    <div>
      ScholarshipsandFellowships
      ScholarshipsandFellowships
    </div>
  );
}

export default ScholarshipsandFellowships;
